import * as React from "react";
const SvgFiRrThermometerAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-thermometer-alt_svg__a)">
      <path
        fill="#062147"
        d="M22.536 1.465A4.97 4.97 0 0 0 19 0a4.97 4.97 0 0 0-3.536 1.465l-11.23 11.23c-1.598 1.597-1.282 5.22-1.068 6.725L.293 22.293a.999.999 0 1 0 1.414 1.414l2.873-2.873c.572.081 1.45.177 2.407.177 1.56 0 3.328-.255 4.318-1.244L22.536 8.536A4.97 4.97 0 0 0 24 5.001c0-1.336-.52-2.592-1.464-3.536m-1.414 5.656L9.892 18.352c-.72.717-3.022.749-4.778.534-.215-1.758-.184-4.059.534-4.777l1.524-1.524 1.622 1.622a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414l-1.622-1.622 2.086-2.086 1.621 1.621a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414l-1.62-1.621 2.085-2.086 1.621 1.621a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414l-1.62-1.621 1.292-1.293a3.003 3.003 0 0 1 4.243 0A2.98 2.98 0 0 1 22 4.999c0 .802-.312 1.556-.878 2.122"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-thermometer-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrThermometerAlt;
